import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DashboardService } from '@services';

@Component({
  selector: 'digicem-comment-dashboard-dialog',
  templateUrl: './comment-dashboard-dialog.component.html',
})
export class CommentDashboardDialogComponent {
  public message: string = '';
  public isLoading = false;

  constructor(
    private dialogRef: MatDialogRef<CommentDashboardDialogComponent>,
    private dashboardService: DashboardService,
    private snackBar: MatSnackBar,
  ) {}

  public onClose(): void {
    this.dialogRef.close();
  }

  public onSubmit(): void {
    if (this.isLoading) return;
    this.isLoading = true;
    if (this.message.trim()) {
      this.dashboardService.commentDashboard(this.message).subscribe({
        next: () => {
          this.dialogRef.close('success');
        },
        error: () => {
          this.snackBar.open('No se pudo guardar el comentario', 'Cerrar', {
            duration: 4000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          });
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    }
  }
}
